import { useAnimations, useAppSelector } from "../hooks";
import classes from "../styles/Bar.module.css";
import { getClasses } from "../utils";
import { useEffect, useRef } from "react";

const Bar: React.FC<{ className?: string }> = (props) => {
  const init = useRef(false);
  const { visible } = useAppSelector(
    (state) => state.details,
    (o, n) => o.visible === n.visible
  );
  const initialClass = useRef(!visible ? "bars-hide-end" : "");

  const [animationClass, playAnimation] = useAnimations({
    show: {
      duration: 0.5,
      main: classes["bars-show"],
      end: classes["bars-show-end"],
    },
    hide: {
      duration: 0.5,
      main: classes["bars-hide"],
      end: classes["bars-hide-end"],
    },
  });

  useEffect(() => {
    if (init.current) {
      const animation = visible ? "show" : "hide";
      playAnimation(animation);
      initialClass.current = "";
    } else {
      init.current = true;
    }
    // eslint-disable-next-line
  }, [init, visible]);

  return (
    <div
      className={getClasses(
        classes,
        "bar",
        props.className,
        initialClass.current,
        animationClass
      )}
    >
      {props.children}
    </div>
  );
};

export default Bar;
